import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "panel", "list", "template"]

  toggle() {
    this.panelTarget.classList.toggle("hidden", !this.checkboxTarget.checked)
  }

  add() {
    this.listTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML.trim())
  }

  remove(event) {
    event.currentTarget.closest("[data-player-invites-target='row']").remove()
  }
}
